<script setup="">
import { MonitorCheckIcon, MoonIcon, SunIcon } from "lucide-vue-next";

import SimpleMenu from "@/Components/SimpleMenu.vue";
import SimpleMenuItem from "@/Components/SimpleMenuItem.vue";

import useTheme from "@/composables/theme";

const theme = useTheme();

const setMode = (type) => {
  theme.setTheme(type);
};
</script>

<template>
  <SimpleMenu>
    <template #button>
      <button class="inline-flex h-8 w-8 items-center justify-center rounded-full">
        <transition
          v-if="theme.isDarkTheme.value"
          enter-active-class="transition-transform duration-200 ease-out absolute origin-top"
          enter-from-class="scale-75"
          enter-to-class="scale-100 static"
        >
          <MoonIcon class="h-6 w-6 text-800" />
        </transition>
        <transition
          v-if="theme.isLightTheme.value"
          enter-active-class="transition-transform duration-200 ease-out absolute origin-top"
          enter-from-class="scale-75"
          enter-to-class="scale-100 static"
        >
          <SunIcon class="h-6 w-6 text-800" />
        </transition>
        <transition
          v-if="theme.isSystemTheme.value"
          enter-active-class="transition-transform duration-200 ease-out absolute origin-top"
          enter-from-class="scale-75"
          enter-to-class="scale-100 static"
        >
          <MonitorCheckIcon class="h-6 w-6 text-800" />
        </transition>
      </button>
    </template>

    <SimpleMenuItem class="flex-center space-x-3" @click="setMode('dark')">
      <MoonIcon class="h-4 w-4 text-800" />
      <span> 다크 </span>
    </SimpleMenuItem>
    <SimpleMenuItem class="flex-center space-x-3" @click="setMode('light')">
      <SunIcon class="h-4 w-4 text-800" />
      <span> 라이트 </span>
    </SimpleMenuItem>
    <SimpleMenuItem class="flex-center space-x-3" @click="setMode('system')">
      <MonitorCheckIcon class="h-4 w-4 text-800" />
      <span>시스템</span>
    </SimpleMenuItem>
  </SimpleMenu>
</template>
